/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum OpenAIEffort {
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
  X_HIGH = "X_HIGH",
}

export const OpenAIEffortDisplay: Record<OpenAIEffort, string> = {
  [OpenAIEffort.MEDIUM]: "Medium",
  [OpenAIEffort.HIGH]: "High",
  [OpenAIEffort.X_HIGH]: "xhigh",
};
